import axios, { AxiosResponse } from 'axios'
import { NPSDataResumo } from './_models'
import { ArquivoDto } from '../../../atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_AVALIACAO_URL = `${API_URL}/atendimentos/avaliacao`

/**
 * Busca resumo NPS
 * @param query search - string
 * @returns NPSDataResumo
 */
export const getResumoNps = (query: string): Promise<NPSDataResumo> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/resumo?${query}`)
    .then((d: AxiosResponse<NPSDataResumo>) => d.data)
}

export const getResumoNpsByEmpresa = (empresaId: number, query: string): Promise<NPSDataResumo> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/resumo/empresa/${empresaId}?${query}`)
    .then((d: AxiosResponse<NPSDataResumo>) => d.data)
}

export const getResumoNpsByProfissionalSaude = (
  profissionalSaudeId: number,
  query: string
): Promise<NPSDataResumo> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/resumo/profissional/${profissionalSaudeId}?${query}`)
    .then((d: AxiosResponse<NPSDataResumo>) => d.data)
}

export const getResumoNpsByTelekit = (query: string): Promise<NPSDataResumo> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/resumo/telekit?${query}`)
    .then((d: AxiosResponse<NPSDataResumo>) => d.data)
}

/**
 * Relatório NPS PDF
 * @param query string
 * @returns ArquivoDto
 */
export const getPdfNps = (query: string): Promise<ArquivoDto> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/relatorio/pdf?${query}`)
    .then((response) => response.data as ArquivoDto)
}

/**
 * Relatório NPS CSV
 * @param query string
 * @returns ArquivoDto
 */
export const getCsvNps = (query: string): Promise<ArquivoDto> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/relatorio/csv?${query}`)
    .then((response) => response.data as ArquivoDto)
}

/**
 * Busca comentarios NPS
 * @param query string
 * @returns string[]
 */
export const getComentariosNps = (query: string): Promise<string[]> => {
  return axios
    .get(`${ATENDIMENTO_AVALIACAO_URL}/comentario?${query}`)
    .then((d: AxiosResponse<string[]>) => d.data)
}
